import {contextify} from 'common/util/react';
import {CurrentUserResource} from 'common/report/model-resources/users';

const context = contextify<CurrentUserResource>();

export const CurrentUserProvider = context.Provider;
export const CurrentUserConsumer = context.Consumer;
